import { useEffect } from 'react';
import { entraLogoutUrl } from './config';

/**
 * Hand-off page between Cognito's /logout and Entra's own end_session_endpoint. Cognito's
 * logout_uri points here (see cognitoSignOutUrl in config.ts) because Cognito's logout never
 * propagates to the federated Entra SSO session on its own.
 */
export default function PostLogout() {
  useEffect(() => {
    window.location.href = entraLogoutUrl();
  }, []);

  return <div>Signing out…</div>;
}
